import { resetTimeFilterDefaults as resetTimeFilterDefaultsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export const resetTimeFilterDefaults = ({ eventEmitter }: ApiMethodBase) => {
    const values = resetTimeFilterDefaultsDiagram();
    eventEmitter.emit(Event.resetTimeFilter, values);
};
